interface PredictionData {
  [city: string]: {
    [year: string]: {
      [metric: string]: {
        value: number;
        // biome-ignore lint/style/useNamingConvention: <explanation>
        is_predicted: boolean;
        // biome-ignore lint/style/useNamingConvention: <explanation>
        lower_bound: number | null;
        // biome-ignore lint/style/useNamingConvention: <explanation>
        upper_bound: number | null;
      };
    };
  };
}

export const prepareChartData = (metric: string, predictionResults: PredictionData | null) => {
  if (!predictionResults) return null;

  const cities = Object.keys(predictionResults);
  const allYears = new Set<string>();

  // Collect all years from all cities
  cities.forEach((city) => {
    Object.keys(predictionResults[city]).forEach((year) => {
      allYears.add(year);
    });
  });

  // Sort years
  const sortedYears = Array.from(allYears).sort();

  // Create datasets for each city
  const datasets = cities.map((city, index) => {
    const data = sortedYears.map((year) => {
      if (predictionResults[city][year] && predictionResults[city][year][metric]) {
        return predictionResults[city][year][metric].value;
      }
      return null;
    });

    // Generate a color based on index
    const hue = (index * 137) % 360;
    const color = `hsl(${hue}, 70%, 60%)`;

    return {
      label: city,
      data,
      fill: false,
      borderColor: color,
      tension: 0.4,
      pointRadius: 5,
      pointBackgroundColor: color,
    };
  });

  return {
    labels: sortedYears,
    datasets,
  };
};

export const getChartOptions = () => {
  return {
    maintainAspectRatio: false,
    aspectRatio: 1.5,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            weight: 'bold',
          },
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Rok',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Hodnota',
        },
        beginAtZero: false,
      },
    },
  };
};
